<template>
    <section class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Combustível' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />
        </div>
        <div class="cursor-pointer mt-1 bg-white flex flex-col justify-center items-center relative">
            <img class="w-72 bg-white" src="@/assets/combustivel/hodometro.svg" alt="">
            <div :style="`transform: rotate(${nivelSelecionado}deg);`"
                class="absolute -bottom-14 flex justify-center items-center origin-center">
                <img src="@/assets/combustivel/ponteiro2.svg" />
            </div>
        </div>
        <input :disabled="resumo" class="w-full h-10 bg-gray-200 rounded-lg bg-azul-padrao cursor-pointer range-sm relative z-10"
            type="range" min="270" max="450" step="45" :value="nivelSelecionado" :oninput="selecionarNivel">
        <BotoesNivelCombustivel @aoSelecionarNivel="selecionarNivelBotao" />
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import BotoesNivelCombustivel from './components/BotoesNivelCombustivel.vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import NiveisCombustivelConstant from '@/constants/NiveisCombustivelConstant';
import Status from '@/components/Status.vue';
import ComponenteCombustivelService from '@/services/componentes/ComponenteCombustivelService';
import ComponentesService from '@/services/ComponentesService';

export default defineComponent({
    name: 'Combustivel',
    components: {
        BotoesNivelCombustivel, 
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        selecionarNivel(event) {
            if(this.resumo) return

            const input = event.target;
            const valor = parseInt(input.value);
            this.nivelSelecionado = valor
            this.salvaComponente(valor)
        },
        selecionarNivelBotao(valor) {
            if(this.resumo) return

            this.nivelSelecionado = valor;
            this.salvaComponente(valor)
        },
        salvaComponente(valor) {
            const nivel = NiveisCombustivelConstant.NIVEIS.find(n => n.valor === valor).nivel;
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, nivel)
            this.statusResposta = ComponenteCombustivelService.controlarStatus(this.respostaObrigatoria, this.etapaComponente, this.identificador, this.modulo)
        }
    },
    setup(props) {
        return ComponenteCombustivelService.setup(props)
    },
});
</script>